import * as React from 'react';

import ReceiptItem from './ReceiptItem';

import type { SaleLine } from '~/renderer/store/receipt/types';

interface ReceiptGroupedItemProps {
  saleLine: SaleLine;
  lineNumber: number;
  hasUntaxedItems: boolean;
}

const GroupedItem: React.FunctionComponent<ReceiptGroupedItemProps> = ({
  saleLine,
  lineNumber,
  hasUntaxedItems,
}) => {
  const id = saleLine.saleLineID;
  const items = saleLine?.items || [];
  const groupDescription = saleLine.Note?.note ?? '';
  const hasItems = !!items.length;

  return (
    <React.Fragment key={id}>
      <ReceiptItem
        saleLine={saleLine}
        lineNumber={lineNumber}
        hasUntaxedItems={hasUntaxedItems}
        description={groupDescription}
        isGroupedItemHead={true}
        hasGroupedItems={hasItems}
      />

      {items.map((item, index) => {
        const description = item.Item?.description ?? '';
        const isLast = index === items.length - 1;

        return (
          <ReceiptItem
            key={item.saleLineID}
            saleLine={item}
            lineNumber={index}
            hasUntaxedItems={hasUntaxedItems}
            isGroupedItem={true}
            isLastGroupedItem={isLast}
            description={description}
          />
        );
      })}
    </React.Fragment>
  );
};

export default GroupedItem;
